import { MessageCircle } from "lucide-react";
import SectionHeading from "../components/SectionHeading";
import { packages } from "../data/siteContent";
import { whatsappUrl } from "../lib/whatsapp";

export default function Packages() {
  return (
    <>
      <section className="page-hero" data-testid="packages-hero-section">
        <div className="container">
          <span className="eyebrow" data-testid="packages-eyebrow">Modern job-search support</span>
          <h1 className="page-title" data-testid="packages-page-title">Support That Fits Your Next Step</h1>
          <p className="page-intro" data-testid="packages-page-intro">Choose a clear starting point, from CV refreshes and interview preparation to full job-search support tailored around your goals.</p>
        </div>
      </section>
      <section className="section compact" data-testid="packages-list-section">
        <div className="container">
          <SectionHeading title="Choose your starting point" text="Pricing stays visible while the focus remains on practical support, clear guidance and confidence-building next steps." testId="packages-list-heading" />
          <div className="card-grid two" data-testid="packages-card-grid">
            {packages.map((item) => (
              <article className="package-card fade-in" key={item.slug} data-testid={`package-${item.slug}-card`}>
                <h3 data-testid={`package-${item.slug}-title`}>{item.title}</h3>
                <div className="price" data-testid={`package-${item.slug}-price`}>{item.price}</div>
                <div className="package-outcome" data-testid={`package-${item.slug}-outcome`}>{item.outcome}</div>
                <p data-testid={`package-${item.slug}-text`}>{item.text}</p>
                <a className="btn btn-primary" href={whatsappUrl(`Hi Ben, I would like a quick quote for ${item.title}.`)} target="_blank" rel="noopener noreferrer" data-testid={`package-${item.slug}-whatsapp-button`}><MessageCircle size={18} /> Ask for a quote</a>
              </article>
            ))}
          </div>
          <div className="note-box" data-testid="packages-price-note">Prices may vary depending on the level of support needed. Message Ben for a quick quote.</div>
        </div>
      </section>
    </>
  );
}